import React, { useState } from "react";
import { RadioGroup, RadioGroupItem } from "src/@/components/ui/radio-group";
import Iconify from "src/components/Iconify";

export const RadioButtonList = ({
    title,
    options,
    onChange,
    selected,
    disabled
}) => {


    return (
            <RadioGroup
                value={selected}
                onValueChange={onChange}
                className="mt-4 flex flex-row"
                disabled={disabled}
            >
                {options.map((option) => (
                    <label
                        key={option.value}
                        className="flex items-center py-2 px-4 border border-gray-300 rounded-lg hover:border-blue-500 transition cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed"
                    >
                        <RadioGroupItem
                            value={option.value}
                            id={option.value}
                            className="mr-3 w-4 h-4 border border-gray-400 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 checked:bg-blue-500"
                        />
                        <Iconify icon={option.icon} className="text-blue-500" />
                        <span className="text-sm text-gray-700">{option.label}</span>
                    </label>
                ))}
            </RadioGroup>

    );
};

